var _ArrowIosLeft;
import ArrowIosLeft from '@crehana/compass.icons.outline/ArrowIosLeft';
import { clsx } from 'clsx';
import { useCollaboratorTranslations } from "../hooks/use-menu-links/use-collaborator-translations";
import { useSidebar } from "../sidebar-context";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var BackButton = function BackButton() {
  var _useCollaboratorTrans = useCollaboratorTranslations(),
    t = _useCollaboratorTrans.t;
  var _useSidebar = useSidebar(),
    sidebarCollapsed = _useSidebar.sidebarCollapsed,
    onClickBackButton = _useSidebar.onClickBackButton;
  return /*#__PURE__*/_jsxs("button", {
    type: "button",
    className: clsx('tw-flex tw-items-center tw-w-full tw-px-1.2 tw-py-1.6 tw-cursor-pointer', 'tw-border-b tw-border-solid dark:tw-border-neutral-dark-700 tw-border-neutral-light-300', {
      'tw-justify-center': sidebarCollapsed
    }),
    onClick: onClickBackButton,
    children: [_ArrowIosLeft || (_ArrowIosLeft = /*#__PURE__*/_jsx(ArrowIosLeft, {
      size: 20,
      className: "tw-text-neutral-light-700"
    })), /*#__PURE__*/_jsx("span", {
      className: "tw-font-link1 tw-text-neutral-light-700 dark:tw-text-neutral-dark-400 ml-4",
      children: sidebarCollapsed ? t('SIDEBAR_BACK') : t('SIDEBAR_BACK_TO_PRODUCTS')
    })]
  });
};